import moment from "moment";

export const initialTableOptions = {
    pageSize: 20,
    pageSizeOptions: [5, 10, 20, 50],
    actionsColumnIndex: -1,
    emptyRowsWhenPaging: false,
    headerStyle: {
        fontSize: 15,
    },
    search: false,
    // have not affect table
    totalData: 0,
    order: "",
    direction: "",
};

export const tableColumns = [
    {
        title: "HN",
        field: "hnNumber",
    },
    {
        title: "ID",
        field: "usersMobileId",
    },
    {
        title: "Name",
        field: "fullname",
    },
    {
        title: "Email",
        field: "email",
    },
    {
        title: "Tel",
        field: "phoneNumber",
    },
    {
        title: "Date",
        field: "createdAt",
        render: row => moment(row?.createdAt).format("DD/MM/YYYY HH:mm"),
    },
    {
        title: "Right",
        field: "patientPlan",
    },
];

export const initailUserMobileFormValues = {
    hnNumber: "",
    patientPlan: "",
    usersMobileId: "",
    fullname: "",
    email: "",
    phoneNumber: "",
    createdAt: "",
    patientPlanObj: {},
    username: "",
    password: "",
    images: "",
    imagePath: "",
};
